/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { OfflineMessaging } from '../Services/OfflineMessaging'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  messagesRequest: ['clearChatId'],
  messagesSuccess: ['response'],
  messagesFailure: null,
  getUnreadMessagesRequest: [],
  getUnreadMessagesSuccess: ['response'],
  getUnreadMessagesFailure: null,
  deleteChatRequest: ['data'],
  deleteChatSuccess: ['response'],
  deleteChatFailure: null,

  updateChatState: ['Chat'],
  chatStopTyping: ['Chat'],
  chatHaveRead: ['chatId'],
  setUpdateCallback: ['data'],
  setUsernames: ['data'],
  chatRequest: ['UserId'],
  chatSuccess: ['response'],
  chatFailure: null,

  chatSendRequest: ['data'],
  chatSendSuccess: ['response'],
  chatSendFailure: null,
  deleteChatSocket : ['data'],
  chatMsg: ['data'],
  chatTyping: ['data']
})

export const MessagesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  OtherUnread : { },
  messages: [], ChatId: '', Opponent : '',
  typing: 0,
  chats: [],
  fetchingChat: false,
  fetching: null,
  unreadMessages: 0,
  sendingChat: false,
  error: null,
  chatError: null,
  fullLoading: false,
  newMessage: null,
  deleteChatSuccess : false,
  updateCallback : ( ) => { },
  aTime : null,
  Usernames : [ ],
  summaries: {
    fetching: false, 
    error: null, 
    messages: [],
    updateCount: 0,
  },
})

/* ------------- Selectors ------------- */

export const MessagesSelectors = {
  getData: state => state.data
}

export const updateChatState = (state, { Chat : { Opponent, ChatId, OtherUnread } }) => state.merge({ Opponent, ChatId, OtherUnread, typing : 0 })
export const setUpdateCallback = (state, { data : cb }) => state.merge({ updateCallback : cb })
export const setUsernames = (state, { data : Usernames }) => {
  console.log('set usernames redux: ', Usernames)
  return state.merge({ Usernames : Usernames })
}
/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state, action) =>
  state.merge({ summaries: { fetching: true, messages: null } })

// successful api lookup
export const success = (state, action) => {
	// console.log("MessagesRedux success, action", JSON.stringify(action))
	const { response: { data: { data } } } = action
	const unreadMessages = action.response.data.meta.UnreadMessageCount
	// console.log("MessagesRedux success, unreadMessages", unreadMessages)
  return state.merge({ unreadMessages, summaries: { fetching: false, error: null, messages: data, updateCount: state.updateCount+1 } })
}

// Something went wrong somewhere.
export const failure = state =>
  state.merge({ summaries: { fetching: false, error: true, messages: [], updateCount: state.updateCount+1 } })

export const chatRequest = (state, action) => {

  return state.merge({ fetchingChat: true, chats: [], chatError: null, Usernames : action.UserId.Username })

}


export const chatMsg = (state, action) => {
  console.tron.log(`chatMsg`)
  OfflineMessaging.chatSuccess( action.data ).then(state.updateCallback).catch(console.warn)
  return state.merge({ typing : 0 })
}
export const chatTyping = (state, action) => state.merge({ typing: Date.now( ) })
export const chatStopTyping = (state, action) => state.merge({ typing: 0 })

export const chatHaveRead = (state, action) => state.merge({})

export const chatSuccess = (state, action) => {
  const { response: { data: { data } } } = action

  let chat = data.length ? data[0] : { ChatId: '', Messages: {} }
    , id = chat.ChatId, messages = chat.Messages, Usernames = []

  return state.merge({
    ChatId: id,
    Usernames: Usernames.length > 0 ? Usernames : state.Usernames,
    messages: state.messages, typing : 0
  })
}


export const chatFailure = (state, error) =>
  state.merge({ fetchingChat: false, chats: null, chatError: error, messages: state.messages, typing : 0 })

export const chatSendRequest = (state, action) => {
  return state.merge({ fullLoading: action.data.PlainText == "[Image]" ? true : false })
}

export const chatSendSuccess = (state, action) => {
  const { response: { data: { data } } } = action
  console.log('chat send success: ', action)
  let message = data[0]
    , parsed = {
      Time: message.TimeStamp, From: message.FromUsername, FromId: message.FromId
      , Message: message.RawMessage, isAnimation: true
    }
  return state.merge({ chats: [...state.chats], messages: state.messages, fullLoading: false, newMessage: parsed })
}
export const chatSendFailure = (state, error) => state.merge({ chatError: error, fullLoading: false, newMessage: null })

export const deleteChatRequest = (state, action) => {
  return state.merge({ messages: state.messages })
}

export const deleteChatSocket = (state, action) => {
  const { data } = action
  return state.merge({ chats: state.chats.filter(message => message.aTimeStamp !== data.aTimeStamp),  fullLoading: false  })
}
export const deleteChatSuccess = (state, action) => {
  const { response } = action
  OfflineMessaging.chatDelete( response ).then(Chat => { console.log('calling update state with data: ', Chat)
    state.updateCallback(Chat)
  }).catch(console.warn)
  return state.merge({ chats: [...state.chats], fullLoading: false, deleteChatSuccess : true })
}
export const deleteChatFailure = (state, error) => state.merge({ chatError: error, fullLoading: false ,deleteChatSuccess : false})

export const getUnreadMessagesRequest = state => state.merge({ unreadMessages: state.unreadMessages })
export const getUnreadMessagesSuccess = (state, action) => {
	const { response: { data: { data: { Unread } } } } = action
	console.log(`getUnreadMessagesSuccess, unread: ${Unread}`);
  return state.merge({ unreadMessages: Unread })
}
export const getUnreadMessagesFailure = (state, error) => state.merge({ chatError: error })
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_CHAT_STATE]: updateChatState,
  [Types.SET_UPDATE_CALLBACK]: setUpdateCallback,
  [Types.SET_USERNAMES]: setUsernames,
  [Types.MESSAGES_REQUEST]: request,
  [Types.MESSAGES_SUCCESS]: success,
  [Types.MESSAGES_FAILURE]: failure,
  [Types.CHAT_REQUEST]: chatRequest,
  [Types.CHAT_SUCCESS]: chatSuccess,
  [Types.CHAT_FAILURE]: chatFailure,
  [Types.CHAT_MSG]: chatMsg,
  [Types.DELETE_CHAT_SOCKET]: deleteChatSocket,
  [Types.CHAT_TYPING]: chatTyping,
  [Types.CHAT_HAVE_READ]: chatHaveRead,
  [Types.CHAT_STOP_TYPING]: chatStopTyping,
  [Types.CHAT_SEND_REQUEST]: chatSendRequest,
  [Types.CHAT_SEND_SUCCESS]: chatSendSuccess,
  [Types.CHAT_SEND_FAILURE]: chatSendFailure,

  [Types.DELETE_CHAT_REQUEST]: deleteChatRequest,
  [Types.DELETE_CHAT_SUCCESS]: deleteChatSuccess,
  [Types.DELETE_CHAT_FAILURE]: deleteChatFailure,

  [Types.GET_UNREAD_MESSAGES_REQUEST]: getUnreadMessagesRequest,
  [Types.GET_UNREAD_MESSAGES_SUCCESS]: getUnreadMessagesSuccess,
  [Types.GET_UNREAD_MESSAGES_FAILURE]: getUnreadMessagesFailure
})
